// API文档相关API
import request from '@/api'

// 查询频道
export async function channelFind(data) {
  return request({
    url: '/capi/community/channel/findAll',
    method: 'post',
    data
  })
}
// 查询标签
export async function getLabel(data) {
  return request({
    url: '/capi/label/v1/tag/batchQuery',
    method: 'post',
    data
  })
}
// 获取用户等级
export async function selectPersonalLevel(data) {
  return request({
    url: `/capi/web-service/experience/selectPersonalLevel`,
    method: 'post',
    data
  })
}
// 获取用户信息
export async function selectPersonalInfo(data) {
  return request({
    url: `/capi/web-service/experience/selectPersonalInfo `,
    method: 'post',
    data
  })
}
// 查询指定用户和文章评论
export async function findComments(data) {
  return request({
    url: `/capi/community/comment/findSuperior`,
    method: 'post',
    data
  })
}
// 获取频道
export async function getChannel(id) {
  return request({
    url: `/capi/community/channel/get/${id}`,
    method: 'post'
  })
}
export async function getUserInfo(id) {
  return request({
    url: `/capi/c-access-layer/account/getUserInfo?userid=${id}`,
    method: 'post'
  })
}
